export default __webpack_public_path__ + "static/media/376.fe383b8e.gif";